import { Component } from '@angular/core';

import {
  AppLanguage,
  LanguageService,
} from '../../portal/shared/services/language.service';

/**
 * Shared AIFC footer, ported from aifc-portal's `vex-footer`.
 */
@Component({
  selector: 'app-aifc-footer',
  templateUrl: './aifc-footer.component.html',
  styleUrls: ['./aifc-footer.component.scss'],
  standalone: false,
})
export class AifcFooterComponent {
  public readonly currentYear = new Date();

  constructor(private languageService: LanguageService) {}

  public get languages(): AppLanguage[] {
    return this.languageService.languages;
  }

  public isActiveLang(lang: AppLanguage): boolean {
    return this.languageService.isActive(lang);
  }

  public setLang(lang: AppLanguage, event: Event): void {
    event.preventDefault();
    this.languageService.use(lang);
  }
}
